// Cross-route handoff for Edit: Comparisons stashes the saved query here and
// navigates to Queries, which opens it (in the builder when it has `sides`,
// else as SPARQL) and clears it. Same $state-module pattern as partnerDraft.

export const queryDraft = $state({ entry: null });
